// extracted by mini-css-extract-plugin
export var main = "_050104bbb3ecbee72c9014abbe7e1f5f-css";
export var favoriteButton = "_7c9c0b91dbe53b940aa8b4bd87044167-css";